// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getAuthHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('ivAccessToken')}`
});
